enum PaymentMethodTypeEnum {
    Transferencia = 1,
    SEPA = 2,
    TPV = 3,

}

export default PaymentMethodTypeEnum;